import * as _ from "lodash";
import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {BundleProduct} from "../services/bundle-product";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ShipmentDriversService} from "../services/shipment-drivers.service";
import {ShipmentDriver} from "../services/shipment-driver";
import {BranchesService} from "../services/branches.service";
import {forkJoin} from "rxjs";
import {UsersService} from "@hassel-it/angular-common";

@Component({
    selector: 'app-shipment-driver-detail',
    templateUrl: './shipment-driver-detail.component.html',
    styleUrls: ['./shipment-driver-detail.component.scss'],
    providers: [ShipmentDriversService, BranchesService]
})

export class ShipmentDriverDetailComponent implements OnInit {

    shipmentDriverId: string;
    bundle: ShipmentDriver;

    requirementProducts: BundleProduct[];
    rewardProducts: BundleProduct[];
    public users: any;
    branches;

    constructor(public activatedRoute: ActivatedRoute,
                public shipmentDriversService: ShipmentDriversService,
                public branchesService: BranchesService,
                public usersService: UsersService,
                public ngbModal: NgbModal) {
        this.shipmentDriverId = activatedRoute.snapshot.params.shipmentDriverId;
    }


    ngOnInit() {

        forkJoin([
                this.usersService.getUsers({all: true}),
                this.shipmentDriversService.getShipmentDriver(this.shipmentDriverId)
            ]
        ).subscribe(
            data => {
                this.setProductsAndBundle(data[1]);
                this.users = data[0].results;
            }
        );

        this.branches = this.branchesService.branchesDetails;

    }

    save() {
        this.shipmentDriversService.updateShipmentDriver(this.bundle).then(bundle => {
            this.setProductsAndBundle(bundle);
        })
    }

    setProductsAndBundle(bundle: ShipmentDriver) {
        this.bundle = bundle;
    }

    branchChanged() {

    }
}
